import { useEffect, useState } from "react";
import {
  inboxMessageCountGenerator,
  fetchMessageCount,
} from "../utilities/inbox/inboxMessageCountGenerator.ts";

function useInboxMessageCountAsyncGenerator() {
  const [unreadMessageCount, setUnreadMessageCount] = useState(0);

  // Force fetch message count when the custom event is triggered.
  // Given that Staff app is currently not an SPA and side nav is rendered both as a component and as a React app,
  // we need to have a mechanism to trigger force fetch the message count from outside the Side nav.
  useEffect(() => {
    const handleForceFetchEvent = () => {
      fetchMessageCount().then((count) => {
        setUnreadMessageCount(count || 0);
        sessionStorage.setItem("lastMessageCountTime", Date.now().toString());
      });
    };

    window.addEventListener("forceFetchInboxMessageCount", handleForceFetchEvent);

    return () => {
      window.removeEventListener("forceFetchInboxMessageCount", handleForceFetchEvent);
    };
  }, []);

  useEffect(() => {
    const controller = new AbortController();
    const generator = inboxMessageCountGenerator();

    (async () => {
      try {
        // Fetch message count when the component is mounted after a new page load
        const initialCount = await fetchMessageCount();
        setUnreadMessageCount(initialCount || 0); // Set the initial count
        // Fetch message count periodically
        for await (const count of generator) {
          const messageCount = count || 0;
          setUnreadMessageCount(messageCount);

          if (controller.signal.aborted) break;
        }
      } catch (error) {
        console.error("Error when fetching message count", error);
      }
    })();

    return () => controller.abort();
  }, []);

  return unreadMessageCount;
}

export { useInboxMessageCountAsyncGenerator };
